import { api } from './client';

export async function getMapData(childId) {
  return api.get(`/map/${childId}`);
}
